import { render, staticRenderFns } from "./FreeBlockEdit.vue?vue&type=template&id=47253594"
import script from "./FreeBlockEdit.vue?vue&type=script&lang=ts"
export * from "./FreeBlockEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47253594')) {
      api.createRecord('47253594', component.options)
    } else {
      api.reload('47253594', component.options)
    }
    module.hot.accept("./FreeBlockEdit.vue?vue&type=template&id=47253594", function () {
      api.rerender('47253594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/FreeBlockEdit.vue"
export default component.exports